export default {
  list: [
    { title: 'موبایل', value: 'MOBILE' },
    { title: 'تلفن', value: 'PHONE' },
    { title: 'اینستاگرام', value: 'INSTAGRAM' },
    { title: 'وب سایت', value: 'WEBSITE' },
    { title: 'ایمیل', value: 'EMAIL' }
  ],
  values: {
    MOBILE: 'MOBILE',
    PHONE: 'PHONE',
    INSTAGRAM: 'INSTAGRAM',
    WEBSITE: 'WEBSITE',
    EMAIL: 'EMAIL'
  }
};
